import React, { useState, useEffect } from 'react';
import { Table, Button, Container, Card } from 'react-bootstrap';
import { apiFetch } from '../../../utils/api.js';

export function Price() {
  const [cards, setCards] = useState([]);

  useEffect(() => {
    apiFetch('/api/cards')
      .then(res => res.json())
      .then(setCards)
      .catch(console.error);
  }, []);

  const handleExport = async () => {
    try {
      const response = await apiFetch('/api/admin/export-price');
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "price_list.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (err) {
      alert("Ошибка при экспорте файла");
    }
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold m-0">Прайс-лист</h2>
        <Button className="btn-corp" onClick={handleExport}>
          <i className="bi bi-file-earmark-excel me-2"></i> Экспорт в Excel
        </Button>
      </div>

      <Card className="border-0 shadow-sm">
        <Card.Body className="p-0">
          <Table hover responsive className="m-0 align-middle">
            <thead className="bg-light">
              <tr>
                <th className="px-4 py-3 border-0">Услуга</th>
                <th className="py-3 border-0">Категория</th>
                <th className="px-4 py-3 border-0 text-end">Цена</th>
              </tr>
            </thead>
            <tbody>
              {cards.map(card => (
                <tr key={card.card_id}>
                  <td className="px-4 py-3 fw-medium">{card.title}</td>
                  <td className="py-3 text-muted">
                    <span className="badge bg-light text-dark fw-normal border">
                      {card.category?.name || 'Без категории'}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-end fw-bold text-accent">от {card.price} ₽</td>
                </tr>
              ))}
              {cards.length === 0 && (
                <tr><td colSpan="3" className="text-center py-5 text-muted">Нет данных для отображения</td></tr>
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
}
